import myDate from '@/common/date.js'
export default {
  namespaced: true,
  state: {
    planData: null,
    selectList: [], //当前选择的补剂产品
    showActivityToast: false
  },
  getters: {},
  mutations: {
    setPlanData(state, b) {
      state.planData = b || null
    },
    setPlanDataId(state, b) {
      if (state.planData) {
        state.planData.plan_id = b
      }
    },
    clearSelectList(state, b) {
      state.selectList = []
    },
    /* 添加补剂 */
    addSelectList(state, b) {
      if (b) {
        state.selectList.push(b)
      }
    },
    /* 删除补剂 */
    deleteSelectList(state, b) {
      if (b) {
        let index = state.selectList.findIndex((item) => {
          return item.product_id == b.product_id
        })
        if (index >= 0) {
          state.selectList.splice(index, 1)
        }
      }
    },
    /*  */
    setShowActivityToast(state, b) {
      if (b) {
        /* 今日已显示过则不再显示 */
        let showToastTime = localStorage.getItem(
          'nutrition-clock-create-clock-toast'
        )
        if (showToastTime) {
          let lastTime = new Date(+showToastTime)
          let today = myDate.isToday(lastTime)
          if (!today) {
            state.showActivityToast = b
          }
        } else {
          /* 本地没有显示过则先显示弹框 */
          state.showActivityToast = b
        }
        localStorage.setItem(
          'nutrition-clock-create-clock-toast',
          new Date().getTime()
        )
      } else {
        /* 隐藏弹框不需要判断 */
        state.showActivityToast = b
      }
    }
  },
  actions: {}
}
